import styled from 'styled-components';
import colors from 'utils/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 1.5rem 0.5rem;
  flex-basis: 50%;
  width: 100%;
  @media (max-width: 1400px) {
    flex-basis: 100%;
  }
`;

export const TypeSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 2px solid ${colors.blueGray};
  margin-top: 1rem;
`;

export const TypeInfo = styled.div`
  font-weight: 300;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0 1.5rem;
`;

export const CategoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1rem 0.5rem;
  width: 100%;
`;

export const CategorySection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 2px solid ${colors.blueGray};
  border-right: 2px solid ${colors.blueGray};
  padding-right: 1rem;
  margin-top: 1rem;
`;

export const CategoryInfo = styled.div`
  font-weight: 300;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0 1.5rem;
`;

export const Score = styled.div`
  color: ${colors.brandingAccent};
  align-self: flex-end;
`;

export const NoScore = styled.div`
  font-weight: 300;
  font-size: 1.2rem;
  color: #fff;
`;
